import { useEffect, useMemo, useState } from "react";

const palettes = [
  ["#0f2d65", "#1274ff", "#f65d4e"],
  ["#143d59", "#20c997", "#f59e0b"],
  ["#2a1c57", "#8b5cf6", "#22c55e"],
  ["#402016", "#ef4444", "#facc15"],
  ["#0c3652", "#06b6d4", "#38bdf8"],
];

const getInitials = (name) =>
  (name || "Dreameer")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

const getPalette = (name) => {
  const hash = Array.from(name || "Dreameer").reduce((total, char) => total + char.charCodeAt(0), 0);
  return palettes[hash % palettes.length];
};

export default function TutorAvatar({
  src,
  name,
  className = "h-20 w-20 rounded-[24px]",
  textClassName = "text-2xl",
  alt,
}) {
  const [failed, setFailed] = useState(false);
  const initials = useMemo(() => getInitials(name), [name]);
  const palette = useMemo(() => getPalette(name), [name]);

  useEffect(() => {
    setFailed(false);
  }, [src, name]);

  const shellClass = `relative overflow-hidden border border-white/70 bg-slate-100 shadow-[0_14px_34px_rgba(15,23,42,0.12)] ${className}`;

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt || `${name} avatar`}
        loading="lazy"
        className={`${shellClass} object-cover`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={`${shellClass} grid place-items-center`}
      style={{
        background: `linear-gradient(135deg, ${palette[0]}, ${palette[1]})`,
      }}
      role="img"
      aria-label={alt || `${name} avatar`}
    >
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background: `radial-gradient(circle at top right, ${palette[2]}, transparent 45%)`,
        }}
      />
      <div className={`relative font-display font-extrabold tracking-[0.18em] text-white ${textClassName}`}>
        {initials}
      </div>
      <div className="absolute bottom-2 right-2 h-3 w-3 rounded-full bg-white/70" />
    </div>
  );
}
